import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useCallback, useContext } from 'react';
import AlertsContext from '~/context/common/AlertsContext';
import { useIsTradeInApplied } from '~/context/common/TradeContext';
import TradeAppliedToastContent from './TradeAppliedToastContent';
import styles from './TradeAppliedToastContent.module.css';
import { ToastActions, type ToastAction } from './types';

export default function useDisplayTradeAppliedToast() {
  const { showToast } = useContext(AlertsContext);
  const appliedTrade = useIsTradeInApplied();

  const displayToast = useCallback(
    (action: ToastAction) =>
      showToast({
        className: styles.tradeAppliedToast,
        label: <TradeAppliedToastContent action={action} />,
        lifetime: 6000,
        position: 'top-center',
        severity: 'custom',
        showClose: false
      }),
    [showToast]
  );

  useSubsequentEffect(() => {
    displayToast(appliedTrade ? ToastActions.add : ToastActions.remove);
  }, [appliedTrade, displayToast]);
}
